import "./App.css";
import React, { useEffect } from "react";
import { Router } from "@reach/router";

import { PrimaryScreen } from "./components/PrimaryScreen";
import LandingScreen from "./components/LandingScreen";
import { QuizScreen } from "./components/Quiz";
import { AboutScreen } from "./components/AboutScreen";
import { hotjar } from "react-hotjar";

import { Layout } from "antd";
import { Navbar } from "./components/Navbar";
const { Content } = Layout;

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      hotjar.initialize(1594105, 6);
    }
  }, []);

  return (
    <Layout className="layout">
      <Navbar />
      <Content>
        <Router>
          <LandingScreen path="/" />
          <QuizScreen path="/quiz" />
          <AboutScreen path="/sobre" />
          <PrimaryScreen path="/camera" />
        </Router>
      </Content>
    </Layout>
  );
}

export default App;
